var audio_rtlignore_default = {
  "fontElementMap": "jRuXp",
  "container": "_3IHZs",
  "customPlayer": "hPNCx",
  "slim": "xFBs0",
  "playPauseButton": "_4TJpS",
  "coverImage": "GG2wF",
  "trackDetailsContainer": "wVRAw",
  "controlsContainer": "f1dzW",
  "controlsGroup": "YK6Ga",
  "sliderContainer": "jwHZa",
  "audioDuration": "f9tMM",
  "isLoading": "QxYDj",
  "audioDetails": "pMfGj",
  "authorName": "OSymR",
  "title": "vhBM0",
  "dropdownMenuWrapper": "_7NdqM",
  "dropdownSelectedButton": "LVc9G",
  "dropdownContent": "_1f8IK",
  "dropdownContentWithIcon": "lXbhg",
  "audioLoader": "_9QZm6"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
